import POS from './index'
import POSPayment from './Payment'
import Invoice from "./components/Invoice"
export const paths = [
    {
        path: '/pos',
        component: POS
    },
    {
        path: '/pos/payment',
        component: POSPayment
    },
    {
        path: '/sale/:id',
        component: Invoice
    }
]
export const POSRouters = {
    icon: 'cash-register',
    path: '/pos',
    testId: '',
    label: "Ponto de Vendas",
    tree: []
}


// WEBPACK FOOTER //
// ./src/views/AppViews/POS/routers.js